"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarketplaceProgram = exports.getGmLogsIDL = exports.getGmIDL = void 0;
const anchor_1 = require("@project-serum/anchor");
const gmIdl_1 = require("./../types/gmIdl");
const gmLogsIdl = __importStar(require("./../types/gmLogsIdl"));
/**
 * Returns the IDL for the Galactic Marketplace program with provided program ID stored in metadata.
 *
 * @param programId - Deployed program ID for Galactic Marketplace
 */
function getGmIDL(programId) {
    const _tmp = gmIdl_1.baseIdl;
    _tmp['metadata']['address'] = programId.toBase58();
    return _tmp;
}
exports.getGmIDL = getGmIDL;
/**
 * Returns the IDL for the GM-Logs program with provided program ID stored in metadata.
 *
 * @param programId - Deployed program ID for GM-Logs
 */
function getGmLogsIDL(programId) {
    const _tmp = gmLogsIdl.baseIdl;
    _tmp['metadata']['address'] = programId.toBase58();
    return _tmp;
}
exports.getGmLogsIDL = getGmLogsIDL;
/**
 * Get the Galactic Marketplace program
 *
 * @param connection - the Solana connection object
 * @param programId - Deployed program ID for Galactic Marketplace
 */
function getMarketplaceProgram({ connection, programId, }) {
    const idl = getGmIDL(programId);
    const provider = new anchor_1.AnchorProvider(connection, null, null);
    const program = new anchor_1.Program(idl, programId, provider);
    return program;
}
exports.getMarketplaceProgram = getMarketplaceProgram;
//# sourceMappingURL=getMarketplaceProgram.js.map